import { useMemo } from "react";

import useApi from "hooks/api";
import { buildLeaveTypesRepository } from "screens/Vacations/components/LeaveTypes/infrastructure";
import { buildPolicyRepository } from "shared/infrastructure";

import { createUseVacation } from "./useVacation";

export const useVacation = ({ colaboraInstanceId }: { colaboraInstanceId: string }) => {
  const { genericApiCall } = useApi();

  const leaveTypesRepository = useMemo(
    () => buildLeaveTypesRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const policyRepository = useMemo(
    () => buildPolicyRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useVacationQuery = useMemo(
    () => createUseVacation({ leaveTypesRepository, policyRepository }),
    [leaveTypesRepository, policyRepository],
  );

  return useVacationQuery({ colaboraInstanceId });
};
